var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionTrackDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "currentColor",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m35.106 37.934 7.48 7.48 2.828-2.828-40-40-2.828 2.828 5.798 5.798a6.003 6.003 0 0 0 1.644 10.456A2.015 2.015 0 0 0 10 22v11.515a8 8 0 0 0 16 0v-4.687l4.066 4.067a6.004 6.004 0 0 0 5.04 5.039ZM22 24.828l-5.212-5.212a6.013 6.013 0 0 1-2.815 2.052c.018.108.027.219.027.332v11.515a4 4 0 1 0 8 0v-8.687ZM11.298 14.127l2.576 2.575a2 2 0 1 1-2.576-2.575Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.797 33.554a6.002 6.002 0 0 0-3.824-7.222A2.02 2.02 0 0 0 38 26V14.485a8 8 0 0 0-15.97-.697l3.97 3.97v-3.273a4 4 0 0 1 8 0v11.272l7.797 7.797Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionTrackDisabled);
export default __webpack_public_path__ + "static/media/ic_action_track_disabled.840de1d9b7ec8bbcb2c392610f8d8a22.svg";
export { ForwardRef as ReactComponent };